import SeoLandingPage from "@/components/feature/SeoLandingPage";
import { seoPages } from "@/data/seoContent";

export default function OnlineDenemeSinavi() {
  const data = seoPages.find((p) => p.slug === "online-deneme-sinavi")!;
  return <SeoLandingPage data={data} />;
}